// ============================================================================
// CONVEX HULL - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'convex-hull',
  name: 'Convex Hull',
  category: 'Geometry',
  complexity: {
    time: 'O(N log N)',
    space: 'O(N)'
  },
  description: 'Computes the smallest convex polygon that contains all given points. Common algorithms include Graham scan and Andrew monotone chain, which sort points and then construct the hull by maintaining a stack of points.'
};
